import { ReactElement, useCallback, useMemo } from 'react';

import { ModalConfirmButton } from '@dreryk/react-components';

import { TimetableActions } from '../../shared/TimetableActions/TimetableActions';
import { VisitsVisibilityPreferences } from '../../shared/TimetableActions/TimetableActions.types';
import { calendarTranslationKeys } from '../../../../translations';
import {
   useCancelledVisibilityPreferenceState,
   useScheduleOnlyVisibilityPreferenceState,
} from '../../shared/preferences/preferences.storage';

import { HealthcareLocationTimetablePreferencesForm } from './form/HealthcareLocationTimetablePreferencesForm';

export const HealthcareLocationTimetableActions = (): ReactElement => {
   const [preferCancelledVisitsVisible, setCancelledVisibilityPreference] = useCancelledVisibilityPreferenceState();
   const [, setScheduleOnlyVisibilityPreference] = useScheduleOnlyVisibilityPreferenceState();

   const visitsVisibilityPreferenceInitialValues = useMemo(
      () => ({
         preferCancelledVisitsVisible: Boolean(preferCancelledVisitsVisible),
      }),
      [preferCancelledVisitsVisible]
   );

   const handleVisitsVisibilityPreferencesChange = useCallback(
      (visitsVisibilityPreferences: VisitsVisibilityPreferences) => {
         setCancelledVisibilityPreference(visitsVisibilityPreferences.preferCancelledVisitsVisible);
      },
      [setCancelledVisibilityPreference]
   );

   return (
      <TimetableActions
         onVisitsVisibilityPreferencesChange={handleVisitsVisibilityPreferencesChange}
         visitsVisibilityPreferencesInitialValues={visitsVisibilityPreferenceInitialValues}
      >
         {({ closeModal }) => (
            <HealthcareLocationTimetablePreferencesForm>
               {({ handleSubmit }) => (
                  <ModalConfirmButton
                     label={calendarTranslationKeys.save}
                     onClick={handleSubmit((values) => {
                        setScheduleOnlyVisibilityPreference(values.preferScheduleOnlyVisible);
                        closeModal();
                     })}
                  />
               )}
            </HealthcareLocationTimetablePreferencesForm>
         )}
      </TimetableActions>
   );
};
